import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const PaginationControls = ({ page, totalPages, setPage }) => {
  if (totalPages <= 1) return null;
  
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <Box sx={{ 
        display: "flex", 
        alignItems: "center", 
        backgroundColor: "white", 
        borderRadius: "50px", 
        px: 2,
        py: 1,
        boxShadow: 1
      }}>
        <Button
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
          sx={{
            minWidth: "40px",
            height: "40px",
            borderRadius: "50%",
            border: "1px solid #e0e0e0",
            mr: 1,
            "&:disabled": {
              opacity: 0.5,
              borderColor: "#e0e0e0"
            }
          }}
        >
          <ChevronLeft />
        </Button>

        {page > 2 && totalPages > 4 && (
          <Typography sx={{ px: 1, color: "text.secondary" }}>...</Typography>
        )}

        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
          .map(p => (
            <Button
              key={p}
              onClick={() => setPage(p)}
              sx={{
                minWidth: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "1px solid #e0e0e0",
                mx: 0.5,
                backgroundColor: page === p ? "#153d7c" : "transparent",
                color: page === p ? "white" : "text.primary",
                "&:hover": {
                  backgroundColor: page === p ? "#153d7c" : "#f5f5f5"
                }
              }}
            >
              {p}
            </Button>
          ))}

        {page < totalPages - 1 && totalPages > 4 && (
          <Typography sx={{ px: 1, color: "text.secondary" }}>...</Typography>
        )}

        <Button
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
          sx={{
            minWidth: "40px",
            height: "40px",
            borderRadius: "50%",
            border: "1px solid #e0e0e0",
            ml: 1,
            "&:disabled": {
              opacity: 0.5,
              borderColor: "#e0e0e0"
            }
          }}
        >
          <ChevronRight />
        </Button>
      </Box>
    </Box>
  );
};

export default PaginationControls; 